<template>
    <span v-if="mostrarBtnSelecionar">
        <b-button variant="primary" @click.stop="abrirModal()" class="float-right">
            <span>
                <i class="fa fa-users"></i> Selecionar Destinatários
            </span>
        </b-button>
        <b-modal id="modalDestinatarios" v-model="mostrarModal" size="lg" @show="atualizarModal()">
            <div slot="modal-title">Destinatários</div>
            <b-row>
                <b-col sm="12">
                    <b-form-group label="Para">
                        <b-form-select :plain="true" :options="paraOpcoes" v-model="paraSel"></b-form-select>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row v-if="paraSel > 0">
                <b-col sm="12">
                    <app-tabela
                        idTabela="tblFornecedores"
                        :itens="fornecedores"
                        :campos="campos"
                        :itensPorPagina="itensPorPagina"
                    >
                        <template slot="cpfCnpj" slot-scope="data">
                            <span>{{ data.cpfCnpj | toCpfCnpj }}</span>
                        </template>
                        <template slot="fornecedorSel" slot-scope="data">
                            <b-form-checkbox :value="data" v-model="selecionados"></b-form-checkbox>
                        </template>
						<template slot="HEAD_fornecedorSel">
							<i
								class="
									fa fa-check-square fa-lg
									text-muted
									icon-button
									p-0
									m-0
								"
								title="Marcar/Desmarcar todos"
								@click.stop="marcarDesmarcarTodas()"
							></i>
						</template>
                    </app-tabela>
                </b-col>
            </b-row>
            <div slot="modal-footer">
                <b-button variant="secondary" @click.stop="fecharModal()">Cancelar</b-button>
                <b-button
                    variant="primary"
                    :disabled="desabilitarSelecionar"
                    @click.stop="selecionarDestinatarios()"
                    class="ml-2"
                >
                    <span>
                        <i class="fa fa-check-square-o"></i> Selecionar
                    </span>
                </b-button>
            </div>
        </b-modal>
    </span>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import MensagensServicos from './MensagensServicos'

export default {
	props: {
		mensagem: {
			type: Object,
			default: () => ({})
		},

		opcaoSel: {
			type: Number
		}
	},

	data() {
		return {
			paraOpcoes: [
				{ text: 'TODOS OS FORNECEDORES', value: 0 },
				{ text: 'FORNECEDORES SELECIONADOS', value: 1 },
				{ text: 'FORNECEDORES COM CONTRATOS', value: 2 },
				{ text: 'FORNECEDORES COM VÍNCULO AO SGF', value: 3 },
				{ text: 'FORNECEDORES COM VÍNCULO AO SGTEC', value: 4 },
				{ text: 'FORNECEDORES COM VÍNCULO EM DESPESAS GERAIS', value: 5 },
			],
			paraSel: null,
			mostrarModal: false,
			selecionados: [],
			fornecedores: [],
			campos: [
				{
					key: 'fornecedorSel',
					label: ''
				},
				{
					key: 'cpfCnpj',
					label: 'CNPJ',
					sortable: true,
					filterable: true
				},
				{
					key: 'razaoSocial',
					label: 'Fornecedor',
					sortable: true,
					filterable: true
				}
			],
			itensPorPagina: 10
		}
	},

	created() {
		this.paraSel = this.opcaoSel
	},

	methods: {
		abrirModal() {
			this.mostrarModal = true
		},

		fecharModal() {
			this.mostrarModal = false
		},

		atualizarModal() {
			if (
				this.mensagem.destinatarios &&
				this.mensagem.destinatarios.length > 0
			) {
				this.selecionados = this.mensagem.destinatarios
			}

			if (this.paraSel > 0) {
				this.obterFornecedoresEscolhiveis()
			}
		},

		obterFornecedoresEscolhiveis() {
			this.$store.dispatch('addRequest')
			let busca = null
			
			switch (this.paraSel) {
				case 2:
					busca = MensagensServicos.obterFornecedoresComContratos()
					break;
				
				case 3:
					busca = MensagensServicos.obterFornecedoresComContratacoes()
					break;
				
				case 4:
					busca = MensagensServicos.obterFornecedoresComProjetos()
					break;
				
				case 5:
					busca = MensagensServicos.obterFornecedoresComDespesas()
					break;
				
				default:
					busca = MensagensServicos.obterFornecedores()
					break;
			}
			
			busca.then(response => {
				if (response) {
					if (response.success) {
						this.fornecedores = response.data
					} else {
						this.$toast.error(
							'Erro ao obter fornecedores!!!',
							'ERROR',
							this.$toastConfig.error
						)
					}
				}
				this.$store.dispatch('removeRequest')
			})
		},

		selecionarDestinatarios() {
			this.$emit('atualizarDestinatarios', this.selecionados)
			this.fecharModal()
		},

		marcarDesmarcarTodas() {
			if (this.selecionados.length > 0) {
                this.selecionados = []
            } else {
				this.selecionados = this.fornecedores
			}
		}
	},

	computed: {
		mostrarBtnSelecionar() {
			let retorno =
				this.$store.getters.fornecedor.fornecedorId === null &&
				this.mensagem.status == 0
			return retorno
		},

		desabilitarSelecionar() {
			if (this.paraSel > 0 && this.selecionados.length == 0) return true
			return false
		}
	},

	watch: {
		paraSel(to) {
			this.$emit('atualizarOpcaoSel', this.paraSel)
			this.selecionados = []

			if (this.paraSel > 0) {
				this.obterFornecedoresEscolhiveis()
			}
		}
	},

	validations: {
		codEvento: {
			required
		}
	}
}
</script>
